/** @jsxImportSource theme-ui */
import React from 'react';
import { useSelector } from 'react-redux';

import { RiskLikelihood, RiskMagnitude } from 'models/RiskCategories';

import riskOverviewSelectors from 'riskOverview/riskOverview.selectors';

import RiskOverviewImportationDescription from './card/RiskOverviewImportationDescription';
import RiskOverviewImportationSummary from './card/RiskOverviewImportationSummary';
import { detailColumnListStyle } from './RiskOverviewStyles';

type RiskOverviewCardCaseImportationDetailsProps = {
  title: string;
  subtitle: string;
  locationId: number;
  diseaseId: number;
  diseaseActivityId: number;
  diseaseRiskMagnitude: RiskMagnitude;
  riskLikelihood: RiskLikelihood;
};

const RiskOverviewCardCaseImportationDetails: React.FC<
  RiskOverviewCardCaseImportationDetailsProps
> = ({
  title,
  subtitle,
  locationId,
  diseaseId,
  diseaseActivityId,
  diseaseRiskMagnitude,
  riskLikelihood,
}) => {
  const isLoadingImportationSources = useSelector(
    riskOverviewSelectors.isLoadingImportationSources(diseaseActivityId, locationId)
  );

  return (
    <div
      sx={{
        width: '100%',
        height: '100%',
        display: [null, 'flex'],
        padding: '0',
      }}
    >
      <RiskOverviewImportationSummary
        riskMagnitude={diseaseRiskMagnitude}
        riskLikelihood={riskLikelihood}
        title={title}
        subtitle={subtitle}
      />
      {!isLoadingImportationSources && (
        <ul sx={detailColumnListStyle}>
          <li>
            <RiskOverviewImportationDescription
              activityId={diseaseActivityId}
              locationId={locationId}
              diseaseId={diseaseId}
              riskMagnitude={diseaseRiskMagnitude}
            />
          </li>
        </ul>
      )}
    </div>
  );
};

export default RiskOverviewCardCaseImportationDetails;
